import axios from "axios";
import { ensureSessionId } from "@/context/LanguageContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Admin uses HttpOnly cookie — no JWT stored in JS. All requests include credentials.
export const adminApi = axios.create({ baseURL: API, withCredentials: true });

export async function trackEvent(event_type, extra = {}) {
  const session_id = ensureSessionId();
  const language = localStorage.getItem("mift_lang") || "en";
  try {
    await api.post("/events", { event_type, session_id, language, ...extra });
  } catch (e) { /* never block UX */ }
}
